import { useState, useEffect, forwardRef } from 'react';
import { Link, useNavigate } from "react-router-dom";

import styledComponent from "styled-components";
import { styled } from '@mui/material/styles';
import { grey } from '@mui/material/colors';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import SettingsIcon from '@mui/icons-material/Settings';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import {
    Autocomplete,
    Box,
    Divider,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    FormControlLabel,
    Grid,
    Typography,
    TextField,
    Button,
    Menu,
    MenuItem,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    Modal,
    InputAdornment,
    InputLabel,
    IconButton,
    Tabs,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    RadioGroup,
    Radio,
    SwipeableDrawer,
    Snackbar,
    Select,
    Stack,
    Paper
  } from "@mui/material";

import MuiAlert from '@mui/material/Alert';

import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import PasswordIcon from '@mui/icons-material/Password';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import axios from  "axios";
import { Formik } from 'formik';

import PropTypes from 'prop-types';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { parse } from 'date-fns';


const Container = styledComponent.div`
    display: flex;
    padding: 25px 17px;
`;

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '80%', md: 400 },
    maxHeight: '68vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflow: 'scroll'
};

const footerStyle = {
    backgroundColor: "#e1e4eb",
    position: "fixed",
    left: "0",
    bottom: "0",
    height: "55px",
    paddingTop: "10px",
    width: "100%",
    display: "flex"
};

const footerItemStyle = {
    flexGrow: '1',
    width: '25%',
    textAlign: 'center'
}

const Puller = styled(Box)(({ theme }) => ({
    width: 30,
    height: 6,
    backgroundColor: theme.palette.mode === 'light' ? grey[300] : grey[900],
    borderRadius: 3,
    position: 'absolute',
    top: 8,
    left: 'calc(50% - 15px)',
}));

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
}));

const FooterNavReadyStock = () => {
    const navigate = useNavigate();
    return (
        <Container>
            <div style={footerStyle}>
                <div style={footerItemStyle}>
                    <CheckCircleIcon color="primary" onClick={() => navigate('/dashboard/konfirmasi')} />
                    <Typography variant="body2">Konfirmasi</Typography>
                </div>
                <div style={footerItemStyle}>
                    <HomeIcon color="primary" onClick={() => navigate('/dashboard')} fontSize="large" />
                </div>
                <div style={footerItemStyle}>
                    <ShoppingBagIcon color="primary" onClick={() => navigate('/dashboard/transaksi')} />
                    <Typography variant="body2">Transaksi</Typography>
                </div>
            </div>
        </Container>
    )
}

export default FooterNavReadyStock
